<template>
<div class="bigBox">
  <ul>
    <li v-for="news in newArr">
      <div class="title">{{news.title}}</div>
      <div class="content">
       <div class="img" v-if="news.imgState"> <img :src="news.imgSrc" alt=""></div>
        <div iv class="content1">
          <span>{{news.date}}</span>
          <span>{{news.content}}</span>
          <p>{{news.name}}</p>
        </div>
      </div>
    </li>
  </ul>
</div>
</template>

<script>
export default {
  name: "Content01",
  data(){
    return{
      newArr:[
        {
          title:"什么是“好房子”?“好房子”好在哪儿?总台记者一线探访→",
          imgState:true,
          imgSrc:require("@/assets/images/Img/home01.webp"),
          content:"前不久，对于到底什么样的房子是“好房子”的问题，住房城乡建设部给出了一个标准答案，好房子归纳起来有四个特征：绿色、低碳、智能、安全。未来，将从好标准、好设计、好...",
          name: "封面新闻",
          date:"2024年10月31日"
        },
        {
          title:"六大优势尽在其中,居住舒适保值无忧,你家的房有这些优势吗?",
          imgState:true,
          imgSrc:require("@/assets/images/Img/home02.webp"),
          content:"六大优势尽在其中，居住舒适保值无忧，你家的房有这些优势吗？随着生活水平的提高，人们购房不再仅仅满足居住的基本需求，而是更加追求居住品质。但是什么样的房子才算“好房...",
          name: "历史说不停TOP",
          date:"2023年9月17日"
        },
        {
          title:"房子,这六大优点全占了,居住舒适还保值,你的房子有吗?",
          imgState:true,
          imgSrc:require("@/assets/images/Img/home03.webp"),
          content:"综上所述，购房时关注房子的这六大优点:低层实用、楼间距合理、环境优良、交通便利、户型方正、物业优秀，就能比较容易买到一套值得长期投资的好房子。如果你的房子在这六个...",
          name: "历史说不停TOP",
          date:"2023年9月19日"
        },
        {
          title:"房子拥有这8大优势,居住舒适升值空间大,具备5个以上别错过",
          imgState:"true",
          imgSrc:require("@/assets/images/Img/home04.webp"),
          content:" 因此，一期房将是企业更用心建造的，质量将更好。第六，楼层在三分之二以上 受地价和成本的因素影响，除了县城，以及城市高端住宅的，许多商品房都是小高层或者高层，楼间距...",
          name: "60秒懂房",
          date:"2022年6月22日"
        },
        {
          title:"我心目中的好房子|好房子是让人感到安心、快乐的地方",
          imgState:true,
          imgSrc:require("@/assets/images/Img/home05.webp"),
          content:"最后，一个好的房子应该拥有和谐的家庭关系。无论房子多么豪华或舒适，如果家庭关系不和睦，那么这个房子就失去了它的意义。我希望我的家庭成员之间可以相互尊重和支持，彼...",
          name: "齐鲁壹点",
          date:"2023年11月17日"
        },
        {
          title:"住建部:好房子的四大标准",
          imgState:true,
          imgSrc:require("@/assets/images/Img/home06.png"),
          content:"8月23日,国新办举行了一场关于“推动高质量发展”的系列主题新闻发布会,住建部的发言人详细解释了什么是“好房子”。“好房子”是一个见仁见智的概念,随着社会的发展和科技...",
          name: "佛系设计昕木",
          date:"2024年12月13日"
        },
        {
          title:"人民日报:“好房子”好在哪儿?",
          imgState:false,
          // imgSrc:require("@/assets/images/Img/home06.png"),
          content:" 当前,人民群众对住房品质有了更高要求,希望住上更好的房子、获得更好的服务。“好房子”好在哪儿?要绿色、低碳、智能、安全,让人民群众住得健康、用得便捷。加...",
          name: "微信公众平台",
          date:"2024年7月23日 "
        },
        {
          title:"如何定义“好房子”?国内外经验与标准解析",
          imgState:false,
          // imgSrc:require("@/assets/images/Img/home06.png"),
          content:"  “好房子”的定义：国内外经验与标准探究 新房、二手房、法拍房、海外房，哪一种才是您心中的“好房子”？当前，政策正积极倡导建设满足国内购房者更高需求的...",
          name: "别抢我的棒棒糖",
          date:"2024年12月24日"
        },
      ]
    }
  }
}
</script>

<style scoped lang="scss">
ul{
  width: 600px;
  min-height: 150px;
  //background: #c27d54;
  margin-left: 140px;
  li{
    margin-top: 30px;
  }
  .title{
    font-size: 18px;
  }
  .content{
    display: flex;
    margin: 6px;
    .img{
      width: 160px;
      height: 100px;
    }
    img{
      width: 160px;
      height: 100px;
      border-radius: 10px;
      margin-top: 5px;
    }
    .content1{
      margin: 2px;
      span:first-child{
     font-size: 13px;
        color: gray;
      }
      span:nth-child(2){
        font-size: 13px;
      }
    p{
      font-size: 13px;
      color: gray;
    }
    }
  }
}

</style>